export default __webpack_public_path__ + "static/icons/mfc-icon-595767b8ff27c38e3c906c5c13d2f606.svg";